import * as apiHelper from './../helpers/apiHelper';

export const loadAccountConfig = (config) => {
	return {
		type: "LOAD_ACCOUNT_CONFIG",
		config
	};
};

export var startLoadAccountConfig = (formData = null) => {
	return (dispatch, getState) => {
		// transform the elements into encoded key-value-pairs
		var url = "configuration?include_groups=Y&include_landlord_selection=Y";

		return apiHelper.apiRequest(url, 'get', formData, dispatch, getState).then((res) => {
			if (res.ok) {
				dispatch(loadAccountConfig(res.json));	
				return res.json;
			} else {
				return null;
			}
		});
	};
};

export var getCounts = () => {
	return (dispatch, getState) => {
		var url = "configuration/counts";
		
		return apiHelper.apiRequest(url, 'get', null, dispatch, getState).then((res) => {
			if (res.ok) {
				return res.json;
			} else {
				return null;
			}
		});
	};
};

export var turnOffGettingStarted = () => {
	return {
		type: "TURN_OFF_GETTING_STARTED"
	};
};

export var startTurnOffGettingStarted = () => {
	return (dispatch, getState) => {
		const url = "users/turnOffGettingStarted";
		dispatch(turnOffGettingStarted());

		return apiHelper.apiRequest(url, 'put', null, dispatch, getState);
	};
};


// WEBPACK FOOTER //
// ./src/actions/configActions.js